import api from 'app/api';
import store from 'app/store';

export const getRequestedEventsList = async (params, callback) => {
  const {
    page_no,
    page_size,
  } = params;

  const successCallback = ({ data, pagination }) => {
    store.dispatch({ type: 'ADMIN_REQUESTED_EVENT_LIST:EVENT_LIST:SET', data: {
      data: data || [],
      totalPages: pagination?.total_pages || 1,
    } });

    if (callback) callback(data);
  };

  await api.get(
    `/events/request`,
    {
      id: 'list-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        page_no: page_no ? (page_no - 1) : 0,
        page_size: page_size || 10,
      },
    },
  );
};

export const deleteRequestedEvent = async (id, callback = () => null) => {
  await api.delete(
    `/events/request/${id}`,
    {
      id: 'delete',
      success: {
        callback: callback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const editRequestedEvent = async (id, payload, callback = () => null) => {
  await api.put(
    `/events/request/${id}`,
    payload,
    {
      id: 'edit-requested-event',
      success: {
        callback: callback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};
